module.exports = __webpack_public_path__ + "static/media/favicon.a28d818a.ico";


//////////////////
// WEBPACK FOOTER
// ./node_modules/loyal-design-system/skins/70916-livvenovo/favicon.ico
// module id = 2318
// module chunks = 14